// extracted by mini-css-extract-plugin
export var collapsedSummary = "_nk-0";